import React from "react";

import { useDeviceRegistrationGroup } from "@dashboard/shared/hooks/useDeviceRegistrationGroup";

import GenerateQRCodeDialog from "./GenerateQRCodeDialog";
import * as Utils from "./GenerateQRCodeDialog.utils";

const createInitialValuesUtil = (licenseCode: string): Utils.FormValues => {
    return {
        ...Utils.initialValues,
        ["android.app.extra.PROVISIONING_ADMIN_EXTRAS_BUNDLE"]: licenseCode ? { UL: licenseCode } : undefined,
    };
};

interface Props {
    isOpen: boolean;
    groupId: number;
    onClose: React.Dispatch<React.SetStateAction<boolean>>;
}

const GenerateQRCodeDialogWrapper = (props: Props) => {
    const { ensureUniversalLicense, getUniversalLicenseCodeForGroup } = useDeviceRegistrationGroup();
    const [licenseCode, setLicenseCode] = React.useState<string | undefined>(getUniversalLicenseCodeForGroup(props.groupId));

    React.useEffect(() => {
        if (!props.isOpen) {
            return;
        }

        ensureUniversalLicense(props.groupId).then((code) => {
            if (code) {
                setLicenseCode(code);
            }
        });
    }, [props.groupId, props.isOpen, ensureUniversalLicense]);

    if (!licenseCode) {
        return null;
    }

    return (
        <GenerateQRCodeDialog
            isOpen={props.isOpen}
            groupId={props.groupId}
            onClose={props.onClose}
            initialValues={createInitialValuesUtil(licenseCode)}
        />
    );
};

export default GenerateQRCodeDialogWrapper;
